@if (noDataAvailable && !isDataLoading) {
    <div class="no-data">
        <span>{{ noDataAvailableMessage }}</span>
    </div>
}

@if (!noDataAvailable) {
    <div class="clearfix" [ngClass]="{'maximized': maximized,'tableHidden': (maximized && !showVizTable)}">
        <div id="vizChartArea" class="vizChart">
            <app-chart #chartViz [chartConfiguration]="chartConfig" [isMaster]="isMaster" [isMaximized]="maximized"></app-chart>
        </div>

        @if (maximized) {
            <div id="vizBigW" class="vizChart-table">
                <div class="vizChart-inner">
                    <div class="vizChart-btn-wrap">
                        <button (click)="toggleVizDataArea()" class="toggle-btn">
                            <span [ngClass]="{'icon-left-expand' : !showVizTable, 'icon-right-expand' : showVizTable}"></span>
                            {{ !showVizTable ? 'Show' : 'Hide' }} Table
                        </button>
                    </div>
                    <div #vizDataArea id="vizDataArea" class="table-wrap" [hidden]="!showVizTable && isManualToggle">
                        <app-big-w-table
                            #bigWTable
                            [widgetId]="widgetId"
                            [chartConfig]="chartConfig"
                            [plottedChartData]="vizChartData"
                            [slicerInfo]="slicerInfo"
                            [chartComponent]="chartViz"
                            [fieldMetadata]="fieldMetadata"
                            [availableHeight]="vizDataArea.getBoundingClientRect().height">
                        </app-big-w-table>
                    </div>
                </div>
            </div>
        }
    </div>
}
